@if (!collapsed()) {
  <app-button
    (clicked)="openDialog(publicRoomsDialog, $event)"
    (keydown.enter)="openDialog(publicRoomsDialog, $event)"
    [dataTestId]="'button_searchpublicroom'"
    class="custom-btn"
    text=""
    tooltip="Öffentliche Chats suchen"
    tooltipPosition="above">
    <mat-icon svgIcon="plus-icon"></mat-icon>
  </app-button>
} @else {
  <app-button
    (clicked)="openDialog(publicRoomsDialog, $event)"
    (keydown.enter)="openDialog(publicRoomsDialog, $event)"
    [dataTestId]="'button_search_publicroom_collapsed'"
    class="custom-btn"
    tooltip="Öffentliche Chats suchen"
    [customWidth]="'5rem'"
    tooltipPosition="right">
    <mat-icon svgIcon="plus-icon"></mat-icon>
  </app-button>
}
<ng-template #actionTemplate let-row>
  <app-button
    text="{{ row.joined ? 'Ansicht' : 'Beitreten' }}"
    (clicked)="row.joined ? viewRoom(row.roomId) : joinRoom(row.roomId)"
    [isDisabled]="false">
  </app-button>
</ng-template>

<ng-template #publicRoomsDialog>
  <div class="dialog-container">
    <div class="dialog-header">
      <h1 class="header">Öffentliche Chats</h1>
      <h2 class="sub-header">Wählen Sie einen Chat aus, um beizutreten oder Details anzusehen.</h2>
    </div>

    <div class="dialog-filter">
      <app-searchbar
        [placeholder]="'Schnellsuche'"
        [dataTestId]="'public_room_search_input'"
        (searchTermChange)="onFilterChange($event)">
      </app-searchbar>
    </div>

    <div class="dialog-body">
      <app-generic-table
        (pageChange)="onPageChange($event)"
        [dataSource]="(rooms$ | async)!"
        [columnsToDisplay]="displayedColumns"
        [pageSize]="itemsPerPage"
        [pageIndex]="pageIndex"
        [totalItems]="total"
        [attr.data-testid]="testIds.publicRoomSearchTable">
      </app-generic-table>
    </div>

    <div class="dialog-footer">
      <app-button [dataTestId]="'public_room_search_close'" (clicked)="reset()" text="Schließen" matDialogClose>
      </app-button>
    </div>
  </div>
</ng-template>
